@if (leftMenu()) {
<nav id="left-nav" class="flex flex-1 flex-col pl-custom-18 pr-2 lg:px-0">
  <ul role="list" class="flex flex-1 flex-col gap-y-5">
    <li>
      <ul role="list" class="space-y-1">
        @if (haveHomeLink) {
        <li>
          <a
            href="#"
            class="item align-icon"
            [ngClass]="{'active': activated(rootUrl)}"
            (click)="__clearMenuState()"
            routerLink="{{ rootUrl }}"
            [track]="{event: 'micrositeEvent', 'eventCategory': 'Homepage', 'eventAction': 'Click', 'eventLabel': 'Homepage', isTracking: true}"
          >
            <i class="icon fa-solid fa-house"></i>
            <span [transloco]="'menu.HOME'"></span>
          </a>
        </li>
        } @if (noContentLink()) {
        <li>
          <a
            href="#"
            class="item align-icon"
            (click)="__clearMenuState()"
            routerLink="/no-content"
            [routerLinkActive]="['active']"
            #rla="routerLinkActive"
            [ngClass]="{'active': activated('/no-content')}"
            [track]="{event: 'micrositeEvent', 'eventCategory': 'Pools_List', 'eventAction': 'Click', 'eventLabel': 'Sports', isTracking: true}"
          >
            <i class="icon fal fa-list-ul"></i>
            <span [transloco]="'menu.POOLS'"></span>
          </a>
        </li>
        }
        <!-- SPORTS -->
        @if (hasSportsMenuItem()) {
        <li>
          <div>
            <button
              type="button"
              class="item item__expand align-icon"
              aria-controls="sub-menu-1"
              aria-expanded="false"
            >
              @if (!singleSportMicrosite() && !noContentLink()) {
              <i class="icon far fa-futbol"></i>
              <span [transloco]="'contentType.SPORTS'"></span>
              } @else {
              <i class="icon fal fa-list-ul"></i>
              <span [transloco]="'menu.POOLS'"></span>
              }
            </button>
            <!-- Expandable link section, show/hide based on state. -->
            <ul class="mt-1 px-2 submenu">
              @for (sportsItem of leftMenu().SPORTS; track sportsItem) {
              <li>
                <!-- 44px -->
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState(sportsItem,false); setDisplayState('SPORTS')"
                  [ngClass]="{'sport-active': menuState().activatedChild === sportsItem.toUpperCase() && !menuState().isSyndicates}"
                  [routerLink]="['/', 'pools', 'sports', sportsItem.toLowerCase()]"
                  [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <span [transloco]="'sports.' + sportsItem"></span>
                </a>
              </li>
              }
              <li class="divider"></li>
              <li>
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState('SPORTS', true)"
                  [ngClass]="{'sport-active': menuState().isResults && menuState().resultsSection === 'SPORTS'}"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="['/', 'pools', 'sports', 'football']"
                  [queryParams]="{results: 'sports'}"
                  [routerLinkActive]="['active']"
                >
                  <span [transloco]="'menu.RESULTS'"></span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        }
        <!-- RACING -->
        @if (hasRacingMenuItem()) {
        <li>
          <div>
            <button
              type="button"
              class="item item__expand align-icon"
              aria-controls="sub-menu-1"
              aria-expanded="false"
            >
              @if (!singleSportMicrosite() && !noContentLink()) {
              <i class="icon fak fa-racing"></i>
              <span [transloco]="'contentType.RACING'"></span>
              } @else {
              <i class="icon fal fa-list-ul"></i>
              <span [transloco]="'menu.POOLS'"></span>
              }
            </button>
            <!-- Expandable link section, show/hide based on state. -->
            <ul class="mt-1 px-2 submenu">
              @for (racingItem of leftMenu().RACING; track racingItem) {
              <li>
                <!-- 44px -->
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState(racingItem, false); setDisplayState('RACING')"
                  [ngClass]="{'sport-active': menuState().activatedChild === racingItem.toUpperCase() && !menuState().isSyndicates}"
                  [routerLink]="['/', 'pools', 'racing', racingItem.toLowerCase().replace('_','-')]"
                  [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <span [transloco]="'sports.' + racingItem"></span>
                </a>
              </li>
              }
              <li class="divider"></li>
              <li>
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState('RACING', true)"
                  [ngClass]="{'sport-active': menuState().isResults && menuState().resultsSection === 'RACING'}"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="['/', 'pools', 'racing', 'horse-racing']"
                  [queryParams]="{results: 'racing'}"
                  [routerLinkActive]="['active']"
                >
                  <span [transloco]="'menu.RESULTS'"></span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        }
        <!-- FANTASY -->
        @if (hasFantasyMenuItem()) {
        <li>
          <div>
            <button
              type="button"
              class="item item__expand align-icon"
              aria-controls="sub-menu-1"
              aria-expanded="false"
            >
              @if (!singleSportMicrosite() && !noContentLink()) {
              <div class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="17"
                  viewBox="0 0 33 32"
                  fill="none"
                >
                  <path
                    d="M16.8332 21.9508C8.23317 21.9508 6.21317 10.1608 6.24317 3.37084C6.24317 2.74084 6.66317 2.20084 7.26317 2.04084C10.7432 1.13084 17.9932 0.230841 26.2832 2.07084C26.9332 2.22084 27.4032 2.79084 27.4032 3.46084C27.4132 10.2608 25.3732 21.9508 16.8232 21.9508H16.8332ZM16.8332 21.9508V27.2308M16.8332 27.2308H13.5432C12.8232 27.2308 12.2032 27.7408 12.0632 28.4408L11.5532 31.0008M16.8332 27.2308H20.1232C20.8432 27.2308 21.4632 27.7408 21.6032 28.4408L22.1132 31.0008M6.27317 5.35084L2.58317 7.20084C2.07317 7.46084 1.75317 7.98084 1.75317 8.55084V12.0108C1.75317 12.5608 2.05317 13.0608 2.53317 13.3308L8.54317 16.6708M27.3932 5.35084L31.0832 7.20084C31.5932 7.46084 31.9132 7.98084 31.9132 8.55084V12.0108C31.9132 12.5608 31.6132 13.0608 31.1332 13.3308L25.1232 16.6708M7.78317 31.0008H25.8932"
                    stroke="#ababab"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M17.0432 5.51107L17.3532 6.56107C17.5632 7.27107 17.9432 7.91107 18.4632 8.43107C18.9832 8.95107 19.6332 9.33107 20.3332 9.54107L21.3832 9.85107C21.5932 9.91107 21.5932 10.2111 21.3832 10.2711L20.3232 10.5811C19.6132 10.7911 18.9732 11.1711 18.4532 11.6911C17.9332 12.2111 17.5532 12.8611 17.3432 13.5611L17.0332 14.6111C16.9732 14.8211 16.6732 14.8211 16.6132 14.6111L16.3032 13.5511C16.0932 12.8411 15.7132 12.2011 15.1932 11.6811C14.6732 11.1611 14.0232 10.7811 13.3232 10.5711L12.2732 10.2611C12.0632 10.2011 12.0632 9.90107 12.2732 9.84107L13.3232 9.53107C14.0332 9.32107 14.6732 8.94107 15.1932 8.42107C15.7132 7.90107 16.0932 7.25107 16.3032 6.55107L16.6132 5.50107C16.6132 5.50107 16.6532 5.41107 16.6932 5.39107C16.7332 5.36107 16.7732 5.35107 16.8232 5.35107C16.8732 5.35107 16.9132 5.37107 16.9532 5.39107C16.9932 5.42107 17.0232 5.46107 17.0332 5.50107L17.0432 5.51107Z"
                    fill="#ababab"
                  />
                </svg>
              </div>
              <span [transloco]="'contentType.FANTASY'"></span>
              } @else {
              <i class="icon fal fa-list-ul"></i>
              <span [transloco]="'menu.POOLS'"></span>
              }
            </button>
            <!-- Expandable link section, show/hide based on state. -->
            <ul class="mt-1 px-2 submenu">
              @for (fantasyItem of leftMenu().FANTASY; track fantasyItem) {
              <li>
                <!-- 44px -->
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState(fantasyItem, false); setDisplayState('FANTASY')"
                  [ngClass]="{'sport-active': menuState().activatedChild === fantasyItem.toUpperCase() && !menuState().isSyndicates}"
                  [routerLink]="['/', 'pools', 'fantasy', fantasyItem.toLowerCase().replace('_','-')]"
                  [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <span [transloco]="'sports.' + fantasyItem"></span>
                </a>
              </li>
              }
              <li class="divider"></li>
              <li>
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState('FANTASY', true)"
                  [ngClass]="{'sport-active': menuState().isResults && menuState().resultsSection === 'FANTASY'}"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="['/', 'pools', 'fantasy', 'fantasy-games']"
                  [queryParams]="{results: 'fantasy'}"
                  [routerLinkActive]="['active']"
                >
                  <span [transloco]="'menu.RESULTS'"></span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        }
        <!-- GENERIC -->
        @if (hasGenericMenuItem()) {
        <li>
          <div>
            <button
              type="button"
              class="item item__expand align-icon"
              aria-controls="sub-menu-1"
              aria-expanded="false"
            >
              @if (!singleSportMicrosite() && !noContentLink()) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 640 640"
                fill="var(--color-soft-text)"
              >
                <path
                  d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM233.8 245.3C241.7 223 262.9 208 286.6 208L344.9 208C379.8 208 408 236.3 408 271.1C408 293.7 395.9 314.6 376.3 325.9L344 344.4C343.8 357.4 333.1 368 320 368C306.7 368 296 357.3 296 344L296 330.5C296 321.9 300.6 314 308.1 309.7L352.4 284.3C357.1 281.6 360 276.6 360 271.2C360 262.8 353.2 256.1 344.9 256.1L286.6 256.1C283.2 256.1 280.2 258.2 279.1 261.4L278.7 262.6C274.3 275.1 260.5 281.6 248.1 277.2C235.7 272.8 229.1 259 233.5 246.6L233.9 245.4zM288 432C288 414.3 302.3 400 320 400C337.7 400 352 414.3 352 432C352 449.7 337.7 464 320 464C302.3 464 288 449.7 288 432zM144 168C144 154.7 154.7 144 168 144C181.3 144 192 154.7 192 168C192 181.3 181.3 192 168 192C154.7 192 144 181.3 144 168zM472 144C485.3 144 496 154.7 496 168C496 181.3 485.3 192 472 192C458.7 192 448 181.3 448 168C448 154.7 458.7 144 472 144zM144 472C144 458.7 154.7 448 168 448C181.3 448 192 458.7 192 472C192 485.3 181.3 496 168 496C154.7 496 144 485.3 144 472zM472 448C485.3 448 496 458.7 496 472C496 485.3 485.3 496 472 496C458.7 496 448 485.3 448 472C448 458.7 458.7 448 472 448z"
                />
              </svg>
              <span [transloco]="'contentType.GENERIC'"></span>
              } @else {
              <i class="icon fal fa-list-ul"></i>
              <span [transloco]="'menu.POOLS'"></span>
              }
            </button>
            <!-- Expandable link section, show/hide based on state. -->
            <ul class="mt-1 px-2 submenu">
              @for (genericItem of leftMenu().GENERIC; track genericItem) {
              <li>
                <!-- 44px -->
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState(genericItem, false); setDisplayState('GENERIC')"
                  [ngClass]="{'sport-active': menuState().activatedChild === genericItem.toUpperCase() && !menuState().isSyndicates && !menuState().isResults}"
                  [routerLink]="['/', 'pools', 'generic', genericItem.toLowerCase().replace('_','-')]"
                  [routerLinkActive]="['active']"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <span [transloco]="'sports.' + genericItem"></span>
                </a>
              </li>
              }
              <li class="divider"></li>
              <li>
                <a
                  href="#"
                  class="sub-item select-none"
                  (click)="setMenuState('GENERIC', true)"
                  [ngClass]="{'sport-active': menuState().isResults && menuState().resultsSection === 'GENERIC'}"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="['/', 'pools', 'generic', 'generic']"
                  [queryParams]="{results: 'generic'}"
                  [routerLinkActive]="['active']"
                >
                  <span [transloco]="'menu.RESULTS'"></span>
                </a>
              </li>
            </ul>
          </div>
        </li>
        } @if (enableFreeplay && !hideFreeplayTab && isAgeVerified()) {
        <li>
          <a
            href="#"
            (click)="__clearMenuState()"
            class="item align-icon"
            routerLink="/freeplay"
            [routerLinkActive]="['active']"
            [track]="{event: 'micrositeEvent', 'eventCategory': 'Freeplay', 'eventAction': 'Click', 'eventLabel': 'List', isTracking: true}"
          >
            <i class="icon fak fa-freeplay"></i>
            <span [transloco]="'poolsMenu.FREEPLAY'"></span>
            @if (freeplays() && freeplays() > 0 && isAgeVerified()) {
            <span class="fp-badge" aria-hidden="true">{{freeplays()}}</span>
            }
          </a>
        </li>
        } @if (syndicatesEnabled && !hideSyndicatesTab) {
        <li>
          <a
            href="#"
            class="item align-icon"
            (click)="resetSyndicateList()"
            routerLink="/syndicates"
            [routerLinkActive]="['active']"
            #rla="routerLinkActive"
            [ngClass]="{'active': activated('/syndicates')}"
            [track]="{event: 'micrositeEvent', 'eventCategory': 'Syndicates', 'eventAction': 'Click', 'eventLabel': 'All', isTracking: true}"
          >
            <i class="icon fas fa-user-friends"></i>
            <span [transloco]="'menu.SYNDICATES'"></span>
          </a>
        </li>
        } @if (isLoggedIn() && !isCashOut) {
        <li>
          <a
            href="#"
            class="item align-icon"
            (click)="resetTicketFilter()"
            routerLink="/tickets"
            [routerLinkActive]="['active']"
            [track]="{event: 'micrositeEvent', 'eventCategory': 'Tickets', 'eventAction': 'Click', 'eventLabel': 'List', isTracking: true}"
          >
            <i class="icon fas fa-ticket-alt"></i>
            <span [transloco]="'menu.TICKETS'"></span>

            @if (groupTicketInvites() > 0) {
            <span class="fp-badge" aria-hidden="true"
              >{{groupTicketInvites()}}</span
            >
            }
          </a>
        </li>
        }

        <!-- special ones -->
        @if (enableUnauthCashout) {
        <li>
          <a
            href="#"
            class="item align-icon"
            (click)="__clearMenuState()"
            routerLink="/tickets/unauth"
            [routerLinkActive]="['active']"
            [track]="{event: 'micrositeEvent', 'eventCategory': 'CashOut', 'eventAction': 'Click', 'eventLabel': 'Unauth', isTracking: true}"
          >
            <i class="icon fas fa-ticket-alt"></i>
            <span [transloco]="'menu.CASHOUT'"></span>
          </a>
        </li>
        }

        <li class="help">
          <a
            href="#"
            class="item align-icon"
            (click)="__clearMenuState()"
            routerLink="/help"
            [routerLinkActive]="['active']"
            [track]="{event: 'micrositeEvent', 'eventCategory': 'Help', 'eventAction': 'Click', 'eventLabel': '', isTracking: true}"
          >
            <i class="icon far fa-question-circle"></i>
            <span [transloco]="'menu.HELP'"></span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</nav>
}
